window.addEventListener('DOMContentLoaded', () => {
   const options = {
      root: null,
      rootMargin: '80px',
      threshold: 0
   }

   const callback = (entries, observer) => {
      entries.forEach(entry => {
         if (entry.isIntersecting) {
            entry.target.classList.add('animation')
         }
      })
   }

   const observer = new IntersectionObserver(callback, options)
   const animateList = document.querySelectorAll('.animate')

   animateList?.forEach(i => {
      observer.observe(i)
   })
})